import React from 'react';
import SortFilterBar from "./SortFilterBar";
import BaseTable from "./BaseTable";
import Input from "../forms/Input";
import PageBar from "./PageBar";
import NoResultsBox from "../cards/NoResultsBox";


export default class PaginatedTable extends React.Component {

    static defaultProps = {
        showPageNavigators: true,
        showSortBar: true,
        data: []
    }


    renderPageBar = () => {

        if (!this.props.showPageNavigators) return;
        return <PageBar {...this.props} format="table"/>
    }


    render() {
        return (
            <div className="container">
                {this.props.showSortBar &&
                    <SortFilterBar
                        {...this.props}
                    />
                }
                    <div className="box">
                        {this.renderPageBar()}

                        {this.props.data.length ?
                        <BaseTable
                            {...this.props}
                        /> :
                            <NoResultsBox/>
                        }

                        {this.renderPageBar()}
                    </div>
            </div>
        )
    }
}
